import _ from 'lodash';

export const getPrTotalSize = pr => {
  return _.get(pr, ['stats', 'pr.net.size.total'], null) !== null
    ? _.get(pr, ['stats', 'pr.net.size.total'])
    : _.get(pr, ['stats', 'pr.size.total']);
};
